module.exports = __webpack_public_path__ + "static/media/instructivoac7.ec41d908.png";